import React, {useContext} from 'react';
import './FormPeriodo.scss';
import DatePicker from 'react-date-picker'
import { AppContext } from '../../global/context' 

function FormPeriodo( {handleClick} ) {
    
    const {dataIni, dataFim, setDataIni, setDataFim} = useContext(AppContext);    

    return(    
        <form className="mt-3">
            <div className="row align-items-center g-3">   
                <div className="col-12 col-md-auto">
                    <label className="form-label" htmlFor="data_inicio">Data Inicial: </label>
                    <DatePicker
                        className="form-control"
                        format='dd/MM/yyyy'                            
                        onChange={(date) => setDataIni(date)}
                        value={dataIni}
                    />                        
                </div> 
                <div className="col-12 col-md-auto">
                    <label className="form-label" htmlFor="data_inicio">Data Final: </label>
                    <DatePicker
                        className="form-control"
                        format='dd/MM/yyyy'                            
                        onChange={(date) => setDataFim(date)}
                        value={dataFim}
                    />                        
                </div> 
                <div className="col-12 col-md-auto">                                
                    <button type="button" className="mt-2 mt-md-4 btn btn-success" onClick={() => handleClick()}>Consultar</button>                                
                </div> 
            </div>                         
        </form>      
    )
}

export default FormPeriodo;
